import axios from 'axios'
import MessageBus from '../buses/MessageBus'
import { Dress } from '../../types/dresses'

/**
 *
 * Add a Dress to a Designer
 */
export const addDress = async (dress: Dress) => {
  try {
    await axios.post<Dress>('/dresses', dress)
    MessageBus.sendMessage('Congratulations! You added a dress.', 'success')
  } catch (err) {
    console.log('Error adding a dress.', err)
    MessageBus.sendMessage('Uh oh. Looks like something went wrong uploading this dress.', 'error')
  }
}

/**
 *
 * Edit a Dress
 */
export const editDress = async (dress: Dress) => {
  try {
    console.log('edit dress: ', dress)
    await axios.put<Dress>(`/dresses/${dress.id}`, dress)
    MessageBus.sendMessage('Congratulations! You edited a dress.', 'success')
  } catch (err) {
    console.log('Error adding a dress.', err)
    MessageBus.sendMessage('Uh oh. Looks like something went wrong editing this dress.', 'error')
  }
}

/**
 *
 * Delete a Dress
 */
export const deleteDress = async (dressId: number) => {
  try {
    await axios.delete<number>('/dresses/' + dressId)
    MessageBus.sendMessage('This dress has been successfully deleted.', 'success')
  } catch (err) {
    console.log('Error deleting a dress.', err)
    MessageBus.sendMessage('Uh oh. Looks like something went wrong deleting this dress.', 'error')
  }
}
